module.exports = __webpack_public_path__ + "img/slide-4.4fafaa44.png";